import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BaseCrudComponent } from 'app/base';
import { Validators } from '@angular/forms';
import { ValidCpfORCnpj } from 'app/util/custom.validators';
import { Helpers } from 'app/util/helpers';

@Component({
  selector: 'cadastro-rapido-instrutor',
  templateUrl: './cadastro-rapido-instrutor.component.html'
})
export class CadastroRapidoInstrutorComponent extends BaseCrudComponent {
  confirmacao: any;
  observableUtilPanelDoc: any;
  service: any;
  controllerName: any;
  router: any;
  cpfMask: any;
  @Output() emitResponse = new EventEmitter<any>();

  @Input() uploadedFiles: any[] = [];
  @Input() listaFormacaoInstrutor: any[] = [];
  @Input() validateForm: any = false;
  @Output() validateFormChange = new EventEmitter<any>();

  cadastro = this.formBuilder.group({
    nome: [null, [Validators.required]],
    cpf_passaporte: [null, [Validators.required, ValidCpfORCnpj]],
    tipo_documento: [1]
  });

  init() {
    this.cpfMask = { mask: Helpers.cpfMask, keepCharPositions: true };
  }

  finalizar(event: any) {
    this.confirmacao.confirm({
      header: 'Mensagem de Confirmação',
      message: `Atenção! Ao confirmar esta operação, você estará cadastrando um novo instrutor.<br>Deseja realmente confirmar esta operação?`,
      accept: () => {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.Adicionar(`instrutor`, this.cadastro.value).subscribe(data => {
          super.showMsgSucess("Sucesso ao salvar instrutor.");
          this.emitResponse.emit(true);
        },

          err => {
            super.showMsgError(`Erro ao tentar salvar novo instrutor. ${err._body}`)
          }
        );

        this.observableUtilPanelDoc.setBlockedPanel(false);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/Componentes/cadastro-rapido-instrutor/cadastro-rapido-instrutor.component.ts